export const convertNumberPercent = (number = 0, minimum = 0) => {
  return (
    new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: minimum,
      maximumFractionDigits: 2,
    }).format(number) + '%'
  );
};
